import type { AxiosRequestConfig } from "axios";

import { NAMES as HEADER_NAMES } from "../header";

import type { LanguageCode } from "~/shared/i18n";

function addAcceptLanguageHeader(languageCode?: LanguageCode): AxiosRequestConfig["headers"] {
  return {
    ...(languageCode && {
      [HEADER_NAMES.acceptLanguage]: languageCode,
    }),
  };
}

export { addAcceptLanguageHeader };
